import Lottie from "lottie-react";
import loadingAnimation from "../assets/lottie/loading.json";

export const ContentLoading = () => {
    let lang = window.localStorage.getItem('i18nextLng') || document.documentElement.lang || 'ar';
    if (lang.includes('en')) {
        lang = 'en';
    } else {
        lang = 'ar';
    }

    return (
        <div className="loading-overlay">
            <div className="loading-content">
                <div className="loading-animation-wrapper">
                    <Lottie
                        animationData={loadingAnimation}
                        loop={true}
                        autoplay={true}
                        className="loading-lottie"
                        style={{ width: "100%", height: "100%", margin: 0, padding: 0 }}
                    />

                </div>
                <div className="loading-text">{lang === 'ar' ? 'جاري التحميل...' : 'loading...'}</div>
            </div>
        </div>
    );
};